import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Disclaimer from './pages/Disclaimer';
import Sitemap from './pages/Sitemap';

function App() {
  const [selectedPlatform, setSelectedPlatform] = useState('tiktok');

  const handlePlatformChange = (platform) => {
    setSelectedPlatform(platform);
    // Scroll to hero section smoothly
    const heroSection = document.querySelector('.hero');
    if (heroSection) {
      heroSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Router>
      <div className="App">
        <Header onPlatformSelect={handlePlatformChange} selectedPlatform={selectedPlatform} />
        <Routes>
          <Route 
            path="/" 
            element={<Home selectedPlatform={selectedPlatform} onPlatformChange={setSelectedPlatform} />} 
          />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/sitemap" element={<Sitemap />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
